/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DoCheck, ElementRef, NgZone } from '@angular/core';
import { MapConfigService } from '../../map/services/map-config.service';
import { RestService } from '../../shared/services/rest.service';
import { ReportContentContainerComponent } from './report-content-container.component';
import { LoggerService } from '../../shared/services/logger.service';
import { DomSanitizer } from '@angular/platform-browser';
import { DataFormService } from '../services/data-form.service';
import { ReportService } from '../services/report.service';
import { ReportDisplayService } from '../services/report-display.service';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { UntypedFormBuilder } from '@angular/forms';
import { IsolatedReportService } from '../services/isolatedReport.service';
import { DeviceService } from '../../shared/services/device.service';
import { ReportContentPrintDetailComponent } from './report-content-detail/report-content-print-detail.component';
import { ReportContentPrintTabularComponent } from './report-content-tabular/report-content-print-tabular.component';
import { ReportContentChartComponent } from './report-content-chart/report-content-chart.component';
import { LayoutDirective, FlexFillDirective } from '@ngbracket/ngx-layout/flex';
import { ReportContentPdfComponent } from './report-content-pdf/report-content-pdf.component';
import { NgTemplateOutlet, AsyncPipe } from '@angular/common';

@Component({
    selector: 'dash-gis-report-content-print',
    templateUrl: './report-content-container-print.component.html',
    styleUrls: ['./report-content-container.component.scss', './report-content-container-print.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        ReportContentPrintDetailComponent,
        ReportContentPrintTabularComponent,
        ReportContentChartComponent,
        LayoutDirective,
        FlexFillDirective,
        ReportContentPdfComponent,
        NgTemplateOutlet,
        AsyncPipe,
    ],
})
export class ReportContentContainerPrintComponent extends ReportContentContainerComponent implements DoCheck {
    constructor(
        logger: LoggerService,
        ngZone: NgZone,
        sanitizer: DomSanitizer,
        reportService: ReportService,
        reportDisplayService: ReportDisplayService,
        isolatedReportService: IsolatedReportService,
        dataFormService: DataFormService,
        deviceService: DeviceService,
        mapConfig: MapConfigService,
        rest: RestService,
        dialog: MatDialog,
        store: Store,
        el: ElementRef,
        fb: UntypedFormBuilder,
        cd: ChangeDetectorRef
    ) {
        super(
            logger,
            ngZone,
            sanitizer,
            reportService,
            reportDisplayService,
            isolatedReportService,
            dataFormService,
            deviceService,
            mapConfig,
            rest,
            dialog,
            store,
            el,
            fb,
            cd
        );
    }

    ngDoCheck() {
        super.ngDoCheck();
    }
}
